import { makeStyles, createStyles } from '../../styles';
export default makeStyles((_) => createStyles({
    root: {
        width: '100%',
    },
}));
//# sourceMappingURL=TextField.styles.js.map